import React from 'react';
import { Avatar, SxProps, Theme } from '@mui/material';
import { useAuthenticatedImage } from '../hooks/useAuthenticatedImage';

interface UserAvatarProps {
    userId: number;
    avatarUrl?: string | null;
    hasAvatar?: boolean;
    initials?: string;
    sx?: SxProps<Theme>;
}

/**
 * Lädt das Profilbild eines Users LAZY über /api/users/<id>/avatar (ein Request pro Bild),
 * statt base64 gesammelt aus einer Liste (RAM-Schutz). Fällt auf Initialen zurück, wenn
 * kein Bild existiert. Bevorzugt eine vom Backend gelieferte avatar_url; sonst wird die URL
 * aus der userId gebaut (nur wenn hasAvatar).
 */
const UserAvatar: React.FC<UserAvatarProps> = ({ userId, avatarUrl, hasAvatar, initials, sx }) => {
    const resolvedUrl = avatarUrl && avatarUrl.trim()
        ? avatarUrl
        : hasAvatar
            ? `/api/users/${userId}/avatar`
            : null;
    const { src } = useAuthenticatedImage(resolvedUrl);

    return (
        <Avatar src={src} sx={sx}>
            {initials}
        </Avatar>
    );
};

export default UserAvatar;
